module.exports = __webpack_public_path__ + "img/mla_alt.ddb60f1b.jpg";